// import { Link } from "react-router-dom";
import { Button, Container, Form, InputGroup } from "react-bootstrap";
import { Formik } from "formik";
// import { AiOutlineUser } from "react-icons/ai";
import { signupInputs } from "../formEntities/signupEntitites";
import { RiLockPasswordFill } from "react-icons/ri";

const SignUpForm = ({ handleFormikSubmit }) => {
  return (
    <section>
      <Formik
        // validationSchema={validationSchema}
        initialValues={{
          email: "",
          firstName: "",
          lastName: "",
          mobileNumber: "",
          password: "",
          confirmPassword: "",
        }}
        onSubmit={(values, actions) => handleFormikSubmit(values, actions)}
      >
        {({ values, handleChange, handleSubmit }) => (
          <Form className="text-center" onSubmit={handleSubmit}>
            {console.log("Values:", values)}
            {signupInputs.map((input, index) => (
              <Form.Group
                key={input.name}
                className="mb-3 text-start"
                controlId={index}
              >
                <Form.Label>{input.label}</Form.Label>
                <InputGroup>
                  {input.prependIcon && <InputGroup.Text>@</InputGroup.Text>}
                  <Form.Control
                    type={input.type}
                    placeholder={input.placeholder}
                    name={input.name}
                    onChange={handleChange}
                    value={values[input.name]}
                  />
                </InputGroup>
              </Form.Group>
            ))}
            <Button type="submit">Sign Up</Button>
          </Form>
        )}
      </Formik>
    </section>
  );
};

export default SignUpForm;
